import React, { useEffect, useState } from 'react';
import PortalTooltip from '../PortalTooltip/PortalTooltip';

interface ShowFirstThenFullTextOnHoverLabelProps {
    items: string[];
    tooltipKey?: string;
}

export const ShowFirstThenFullTextOnHoverLabel = (
    props: ShowFirstThenFullTextOnHoverLabelProps
) => {
    const [firstItem, setFirstItem] = useState(
        props.items.find((x) => x) ?? ''
    );

    useEffect(() => {
        setFirstItem(props.items.find((x) => x) ?? '');
    }, [props.items]);

    const getTooltipId = () => {
        return `tooltip-${firstItem}-${props.tooltipKey}`;
    };

    const getTooltipContent = () => {
        return (
            <>
                {props.items.map((item, index) => (
                    <React.Fragment key={index}>
                        {item}
                        <br />
                    </React.Fragment>
                ))}
            </>
        );
    };

    return props.items.length > 1 ? (
        <span id={getTooltipId()} style={{ cursor: 'pointer' }}>
            {firstItem} +
            <PortalTooltip
                anchorId={getTooltipId()}
                delayShow={200}
                place="top"
                content={getTooltipContent()}
            />
        </span>
    ) : (
        <span>{firstItem}</span>
    );
};
